import { SET_QUIZ } from 'utils/constant'
import storage from 'utils/storage'
export default {
  state: {
    quiz: {
      quizNum: 0, // 第几题
      allTime: 0, // 花费总时间
      answerid: [],
      answerDetail: [],
      examPaper: {
        answerQuestions: [],
        judgeQuestions: [],
        multiselectQuestions: [],
        radioQuestions: []
      }
    }
  },
  getters: {
    quiz: state => state['quiz']
  },
  mutations: {
    [SET_QUIZ](state, quiz) {
      storage.set('quiz', quiz)
      state.quiz = storage.get('quiz')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/quiz/index.js